<script>
import Layout from "@/views/layouts/static/main";
import PageHeader from "@/components/static/page-header";
import appConfig from "@/app.config";
import notification from "@/components/notifications/notification";

export default {
  page: {
    title: "Team",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,notification
  },

 data() {
    return {
       items: [
        {
          text: "Notifications",
        },
        {
          text: "All",
          active: true,
        },
      ],
      notifications:[],

  }
 },
  

 mounted(){
   document.body.classList.add("authentication-bg");
  },

  methods:{
     
  },

  middleware: "authentication",
};
</script>

<template>
  <Layout>
    <PageHeader :items="items" />
            <notification></notification>
    
  </Layout>
</template>
